import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { PRODUCT, IMAGES } from "../constants/site";
import { comboLineTotal } from "../constants/site";
import { trackEvent } from "../components/MetaPixel";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("omnimist_cart_v2") || "[]");
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("omnimist_cart_v2", JSON.stringify(items));
  }, [items]);

  const add = (qty = 1) => {
    trackEvent("AddToCart", {
      content_name: PRODUCT.name,
      value: PRODUCT.price * qty,
      currency: "INR",
      num_items: qty,
    });
    setItems((prev) => {
      const existing = prev.find((i) => i.id === PRODUCT.id);
      if (existing) {
        return prev.map((i) =>
          i.id === PRODUCT.id ? { ...i, qty: Math.min(20, i.qty + qty) } : i
        );
      }
      return [
        ...prev,
        {
          id: PRODUCT.id,
          name: PRODUCT.name,
          capacity: PRODUCT.capacity,
          price: PRODUCT.price,
          image: IMAGES.studio,
          qty,
        },
      ];
    });
  };

  const setQty = (id, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.id !== id)
        : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(20, qty) } : i))
    );

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + comboLineTotal(i.qty), 0);

  const value = useMemo(
    () => ({ items, isOpen, setIsOpen, add, setQty, remove, clear, count, subtotal }),
    [items, isOpen]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
